import { render, staticRenderFns } from "./PixType.vue?vue&type=template&id=086cfae8&"
import script from "./PixType.vue?vue&type=script&lang=ts&"
export * from "./PixType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports